<h1>{{ title }}</h1>

<div class="card-frame">
  <ng-content></ng-content>
</div>
